import('./path.css')

export default function Path(opts={}){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let options = opts.options || {}
    let _path, _info_container_el, _title_el,_flow_el

    this.generate = () =>{
        let {position, title} = options
        
        
        

        _path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        _path.classList.add('vertical')
        _path.setAttribute('fill', 'none');
        _path.setAttribute('stroke', '#66c9ff');
        _path.setAttribute('stroke-width', '15px')

        setPosition()

        $(container).append(_path)

        window.addEventListener('resize', setPosition)
        
    }

    const setPosition = _ =>{
        const convertPosition = (pos, type) =>{
            let container_w = $(container).width()
            let container_h = $(container).height()
            if(type == 'w'){
                return pos * container_w / 100
            } else {
                return pos * container_h / 100
            }
        }
        _path.setAttribute('d', `M ${convertPosition(options.position.start[0],'w')} ${convertPosition(options.position.start[1])} ${options.position.points.map(x=> convertPosition(x[0], 'w')+ " " + convertPosition(x[1], 'h') )}`);
    }

    this.setFlow = () =>{
        if(!_info_container_el){
            _info_container_el = this.createElement('div', 'vline-info-container')    
        }

        _flow_el = this.createElement('div', '', '<span class="flow-icon-container"><i class="fas fa-angle-double-left"></i></span>')
        _flow_el.classList.add('line-flow-container')
        $(_info_container_el).append(_flow_el)

        // this.updateFlowPosition()
    }

    this.setTitle = _ =>{
        let {title} = options
        if(!_info_container_el){
            _info_container_el = this.createElement('div', 'vline-info-container')    
        }
        _title_el = this.createElement('div', '', title.text)
        _title_el.classList.add('line-title-container')
        $(_info_container_el).append(_title_el)

        this.updateInfoPosition()

    }

    this.updateInfoPosition = _ =>{

        let offset = $(_path).offset()
        let box = _path.getBBox()
        let svg_size = $(container)[0].clientWidth

        $(_info_container_el).css({
            position: 'absolute',
            top: offset.top,
            left: offset.left,
            width: (box.width * svg_size / 100),
            height: '3%'
        })
    }
    this.update = () =>{
        
    }
}

Path.prototype = Object.create(BaseConstructor.prototype)